/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ClientResponse = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ClientResponse model module.
   * @module model/ClientResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ClientResponse</code>.
   * A response object that includes the information of the client.
   * @alias module:model/ClientResponse
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>ClientResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ClientResponse} obj Optional instance to populate.
   * @return {module:model/ClientResponse} The populated <code>ClientResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('isActive')) {
        obj['isActive'] = ApiClient.convertToType(data['isActive'], 'Boolean');
      }
      if (data.hasOwnProperty('allowedOrigins')) {
        obj['allowedOrigins'] = ApiClient.convertToType(data['allowedOrigins'], ['String']);
      }
      if (data.hasOwnProperty('allowedIpAddresses')) {
        obj['allowedIpAddresses'] = ApiClient.convertToType(data['allowedIpAddresses'], ['String']);
      }
      if (data.hasOwnProperty('sharedMode')) {
        obj['sharedMode'] = ApiClient.convertToType(data['sharedMode'], 'String');
      }
      if (data.hasOwnProperty('apiKey')) {
        obj['apiKey'] = ApiClient.convertToType(data['apiKey'], 'String');
      }
      if (data.hasOwnProperty('apiSecret')) {
        obj['apiSecret'] = ApiClient.convertToType(data['apiSecret'], 'String');
      }
      if (data.hasOwnProperty('grantedRoles')) {
        obj['grantedRoles'] = ApiClient.convertToType(data['grantedRoles'], ['String']);
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('ownerId')) {
        obj['ownerId'] = ApiClient.convertToType(data['ownerId'], 'String');
      }
      if (data.hasOwnProperty('clientType')) {
        obj['clientType'] = ApiClient.convertToType(data['clientType'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ID of the client.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * A value indicates whether the client is active or not.
   * @member {Boolean} isActive
   */
  exports.prototype['isActive'] = undefined;
  /**
   * The whitelist of the origins that are allowed to pass the APIs.
   * @member {Array.<String>} allowedOrigins
   */
  exports.prototype['allowedOrigins'] = undefined;
  /**
   * The whitelist of the origins that are allowed to pass the APIs.
   * @member {Array.<String>} allowedIpAddresses
   */
  exports.prototype['allowedIpAddresses'] = undefined;
  /**
   * Indicates either \"Origin\" or \"IP Address\" is used to as the whitelist for requests.
   * @member {module:model/ClientResponse.SharedModeEnum} sharedMode
   */
  exports.prototype['sharedMode'] = undefined;
  /**
   * The API key of the client. This key is used to append to the query parameter \"apiKey\" or used to sign on with \"client_credential\".
   * @member {String} apiKey
   */
  exports.prototype['apiKey'] = undefined;
  /**
   * The API secret of the client. This value is used to sign on with \"client_credential\".
   * @member {String} apiSecret
   */
  exports.prototype['apiSecret'] = undefined;
  /**
   * The roles granted to the client.
   * @member {Array.<String>} grantedRoles
   */
  exports.prototype['grantedRoles'] = undefined;
  /**
   * The name of the client.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * The ID of the account that the client is belongs to.
   * @member {String} ownerId
   */
  exports.prototype['ownerId'] = undefined;
  /**
   * The type of the client. The supported values are \"JavaScript\" and \"NativeConfidential\".
   * @member {module:model/ClientResponse.ClientTypeEnum} clientType
   */
  exports.prototype['clientType'] = undefined;


  /**
   * Allowed values for the <code>sharedMode</code> property.
   * @enum {String}
   * @readonly
   */
  exports.SharedModeEnum = {
    /**
     * value: "Origin"
     * @const
     */
    "Origin": "Origin",
    /**
     * value: "IpAddress"
     * @const
     */
    "IpAddress": "IpAddress"  };

  /**
   * Allowed values for the <code>clientType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ClientTypeEnum = {
    /**
     * value: "JavaScript"
     * @const
     */
    "JavaScript": "JavaScript",
    /**
     * value: "NativeConfidential"
     * @const
     */
    "NativeConfidential": "NativeConfidential"  };


  return exports;
}));



